import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { OnboardingWidgetSetup } from "@/components/onboarding/onboarding-widget-setup";
import { OnboardingProgress } from "@/components/onboarding/onboarding-progress";
import { SkipButton } from "@/components/onboarding/skip-button";

export function OnboardingWidgetPage() {
  const navigate = useNavigate();

  // No pricing detour: an unsubscribed organization is prompted to pick a plan
  // by the card in the dashboard sidebar.
  const handleNext = () => {
    navigate("/");
  };

  return (
    <div className="space-y-8">
      <SkipButton href="/" fixed />

      <OnboardingProgress
        currentStep={4}
        title="Add a widget to your phone's home screen"
        description="Select the Appio app and choose the widget size."
      />

      <OnboardingWidgetSetup />

      <div className="flex justify-center">
        <Button onClick={handleNext}>Next</Button>
      </div>
    </div>
  );
}
